import React, { Component } from 'react';

import { Link } from '~/lib/react-router-dom';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import { Alert, Collapse, IconButton, Typography } from '@mui/material';

import { LIST_VISIBILITY } from '../../../consts/schedule';
import { types } from '../../../consts/types';
import { scheduleForType } from '../../../utils/scheduleForType';

import Visibility from './Visibility';

type Props = {
  offer: {
    result: App.Offer;
  };
  schedules: App.Offer['brand_schedules'];
};

type State = {
  isInfoOpen: boolean;
};

export default class SchedulePane extends Component<Props, State> {
  state: State = { isInfoOpen: false };

  formatDate = (date_in: string) => {
    const date = new Date(date_in);
    return date.toDateString();
  };
  render() {
    const { offer, schedules } = this.props;
    const { isInfoOpen } = this.state;
    const offerId = offer.result.id_salesforce_external;

    return (
      <span>
        <h1 className="page-header" data-testid="offer-detail-schedule-header">
          Schedule
          <Link to={`/edit-offers/${offerId}/schedules`}>
            <IconButton aria-label="Edit">
              <ModeEditTwoToneIcon fontSize="large" />
            </IconButton>
          </Link>
        </h1>
        <div className="panel-section">
          <div className="schedule-summary">
            {types.map((type, index) => {
              return (
                <div key={`${index}-${type.code}`}>
                  <span className="h6 text-uppercase text-muted">{type.name}</span>
                  <span>
                    <div className="date">
                      {scheduleForType(schedules, type.code, 'start') ? (
                        <span className="date-labels">
                          <div className="date-start">
                            {this.formatDate(scheduleForType(schedules, type.code, 'start'))}
                          </div>
                          <div className="date-arrow">&#8594;</div>
                          <div className="date-end">
                            {this.formatDate(scheduleForType(schedules, type.code, 'end'))}
                          </div>
                        </span>
                      ) : (
                        <div className="empty">No Schedule Set</div>
                      )}
                    </div>
                  </span>
                </div>
              );
            })}
          </div>
          <Alert
            severity="info"
            variant="outlined"
            icon={false}
            sx={{ mt: 3, mb: 1, cursor: 'pointer' }}
            onClick={() => this.setState((prev) => ({ isInfoOpen: !prev.isInfoOpen }))}
          >
            <Typography variant="body2" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              How customers find and buy this offer
              {isInfoOpen ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
            </Typography>
            <Collapse in={isInfoOpen}>
              <Typography variant="body2" component="ul" sx={{ m: 0, mt: 0.5, pl: 2.5 }}>
                <li>
                  <strong>Book by dates</strong> &mdash; only staff can purchase on behalf of a customer. Customers
                  cannot book their buy now, choose dates later orders after this date.
                </li>
                <li>
                  <strong>Available offline</strong> &mdash; can be bought via a direct link but is not accessible via
                  search or carousels.
                </li>
                <li>
                  <strong>List visibility</strong> &mdash; appears in search results and carousels.
                </li>
              </Typography>
            </Collapse>
          </Alert>
          <Visibility offerId={offerId} schedules={schedules} type={LIST_VISIBILITY} />
        </div>
      </span>
    );
  }
}
